import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { useStyles } from '../styles/addSectionStyles';
import { createSection } from '../../../../services/sectionService';

const AddSection = ({ refetchSection }) => {
  const { id } = useParams();
  const classes = useStyles();
  const inputRef = useRef(null);
  const [openAdd, setOpenAdd] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleOpen = useCallback(() => setOpenAdd(true), []);
  const handleClose = useCallback(() => setOpenAdd(false), []);

  const handleSave = useCallback(async () => {
    try {
      const name = inputRef.current?.value?.trim();
      if (name?.length > 0) {
        // save the section
        setDisabled(true);
        await createSection({ name, projectId: id }); // success message: response.data.message
        refetchSection();
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || 'An error occurred while saving the section. Please try again later.';
      toast.error(errMsg);
    } finally {
      handleClose();
      setDisabled(false);
    }
  }, [handleClose, refetchSection, id]);

  const handleKeyDown = useCallback(
    (event) => {
      // When the user presses Esc key
      if (event.keyCode === 27) handleClose();

      // When the user presses Enter key
      if (event.keyCode === 13) handleSave();
    },
    [handleClose, handleSave]
  );
  return (
    <Box className={classes?.section}>
      {openAdd ? (
        <TextField
          onBlur={handleSave}
          autoFocus
          placeholder="Enter section name"
          size="small"
          className={classes?.header}
          onKeyDown={handleKeyDown}
          inputRef={inputRef}
          disabled={disabled}
        />
      ) : (
        <IconButton className={classes?.header} onClick={handleOpen}>
          <Add />
          <Typography variant="h5">Add Section</Typography>
        </IconButton>
      )}
    </Box>
  );
};

AddSection.propTypes = {
  refetchSection: PropTypes.func,
};

export default AddSection;
